module.exports = {
	"id": "wdwd.logistics.companies.get",
	"description": "获取物流公司代码和名称",
	"meta": {
		"oauth": false
	},
	"requests": {
		"urls": [
			{
				"name": "正式环境",
				"http": "http://openapi.wdwd.com/api/gateway?method=wdwd.logistics.companies.get",
				"https": "https://openapi.wdwd.com/api/gateway?method=wdwd.logistics.companies.get"
			},
			{
				"name": "沙箱环境",
				"http": "http://openapi.sandbox.wdwd.com/api/gateway?method=wdwd.logistics.companies.get",
				"https": "https://openapi.sandbox.wdwd.com/api/gateway?method=wdwd.logistics.companies.get"
			}
		],
		"params": {
			"share": [],
			"private": []
		}
	},
	"responses": {
		"exceptions": [],
		"params": [
			{
				"name": "logistics_companies",
				"type": "logistics_companies",
				"description": "快递公司名称和标示"
			}
		]
	},
	"structure": [
		{
			"name": "logistics_companies",
			"params": [
				{
					"name": "code",
					"type": "string",
					"enumerable": false,
					"description": "物流公司代码"
				},
				{
					"name": "name",
					"type": "string",
					"enumerable": false,
					"description": "物流公司名称"
				}
			]
		}
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./app/data/api/wdwd.logistics.companies.get.json
 ** module id = 527
 ** module chunks = 1
 **/